import axios from "axios";
import {notify} from "@kyvg/vue3-notification";

export default {
    namespaced: true,

    state: () => ({
        textList: [],
        text: [],
        currentTitles: [],
        totalListCount: null,
    }),

    mutations: {
        setTextList(state, data) {
            state.textList = data?.data;
        },
        setText(state, data) {
            state.text = data;
        },
        setTotalListCount(state, data) {
            state.totalListCount = data;
        },
        setCurrentTitles(state, data) {
            state.currentTitles = data;
        }
    },

    actions: {
        async getTexts({ commit }, data) {
            await axios.post(`/reports_text/search`, data).then(({ data }) => {
                commit("setTextList", data);
                commit("setTotalListCount", data?.meta.total)
            });
        },
        async getText({ commit }, id) {
            await axios.get(`/reports_text/get/${id}`).then(({ data }) => {
                commit("setText", data);
            });
        },
        async createText({ commit }, data) {
            await axios.post(`/reports_text/create`, data).then(() => {
                notify({
                    title: "Текст сохранен",
                    type: "success",
                });
            });
        },
        async updateText({ commit }, data) {
            await axios.post(`/reports_text/update/${data.id}`, data).then(() => {
                notify({
                    title: "Изменения сохранены",
                    type: "success",
                });
            });
        },
        async getTitles({ commit }, type) {
            await axios.get(`/reports_text/get/title/list/${type}`).then(({ data }) => {
                commit("setCurrentTitles", data);
            });
        },
    }
}
